import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, HeadingStyled, LazyImage, MainHeading, PrimaryHeading, SpanStyled, TextStyled } from '../../ui/Elements'
import { AboutBg, AboutImg, AbtTxtImg, ArrowBtnBrown, ArrowBtnBrown2, ExpertiseBg, ExpIcon1, ExpIcon2, ExpIcon3, OurGoals, OurMission, OurVision, ServicesBg, ServicesBg1, ServicesBg2, ServicesBg3, ServicesBg4, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { AboutData } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
const Services = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // run animation once
                }
            },
            {
                threshold: 0.2, // 20% of section visible triggers the animation
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    
    const start = i18n.language === "ar"
    ? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
    : { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
    const end = { clipPath: "inset(0 0% 0 0)" };
    const start2 = { opacity: 0, transform: 'translateY(-20px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    const start3 = { opacity: 0, transform: 'translateY(0px)' };
    const end3 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <Box  id='services'>
            <ServicesWapper className='container-fluid secAbout common-space' ref={sectionRef}>
                <Container>
                    <Row className='about-row'>
                        <Animate
                                                    play={isVisible}
                                                    duration={1.5}
                                                    delay={-1}
                                                    
                        
                                                    start={start}
                                                    end={end}
                                                >
                        <PrimaryHeading className='main-heading mb-5 primary-heading'>
                            {t('servicesH1')}
                        </PrimaryHeading>
                        </Animate>
                        <Col md={12} className='about-h-row'>
                        <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.8}
                                                        start={start2}
                                                        end={end2}
                                                    >
                            <MainHeading className='main-heading mb-3 main-heading-about' size="40px">
                                <SpanStyled className='servicesT1'>{t('servicesT1')}</SpanStyled> <SpanStyled className='servicesT2'>{t('servicesT2')}</SpanStyled> <SpanStyled className='servicesT3'>{t('servicesT3')}</SpanStyled> <SpanStyled className='aboutH4'>{t('aboutHeading4')}</SpanStyled> 
                            </MainHeading>
                            </Animate>
                        </Col>
                        <Col md={12} className=''>
                            <Row className=''>
                                
                                    <Col lg={6} md={12} className='servBoxCol'>
                                        <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={1.2}
                                            start={start3}
                                            end={end3}
                                        >
                                            <Box className='servBox servBox1'>
                                                <Box className='servBoxNum'>
                                                    01
                                                </Box>
                                                <Box className='servBoxContWrap'>
                                                    <span className='servTitle'>
                                                        {t('servicesL1Title')}
                                                    </span>
                                                    <span className='servTxt'>
                                                        {t('servicesL1Txt')}
                                                    </span>
                                                </Box>
                                            </Box>
                                        </Animate>
                                    </Col>
                                
                                <Col lg={6} md={12} className='servBoxCol'>
                                <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={1.6}
                                            start={start3}
                                            end={end3}
                                        >
                                    <Box className='servBox servBox2'>
                                        <Box className='servBoxNum'>
                                            02
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                {t('servicesL2Title')}
                                            </span>
                                            <span className='servTxt'>
                                                {t('servicesL2Txt')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col lg={6} md={12} className='servBoxCol'>
                                <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={2}
                                            start={start3}
                                            end={end3}
                                        >
                                    <Box className='servBox servBox3'>
                                        <Box className='servBoxNum'>
                                            03
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                {t('servicesL3Title')}
                                            </span>
                                            <span className='servTxt'>
                                                {t('servicesL3Txt')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                                <Col lg={6} md={12} className='servBoxCol'>
                                <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={2.4}
                                            start={start3}
                                            end={end3}
                                        >
                                    <Box className='servBox servBox4'>
                                        <Box className='servBoxNum'>
                                            04
                                        </Box>
                                        <Box className='servBoxContWrap'>
                                            <span className='servTitle'>
                                                {t('servicesL4Title')}
                                            </span>
                                            <span className='servTxt'>
                                                {t('servicesL4Txt')}
                                            </span>
                                        </Box>
                                    </Box>
                                    </Animate>
                                </Col>
                            </Row>
                        </Col>

                        
                    </Row>
                </Container>
                
            </ServicesWapper>
            
        </Box>
    )
}
const ServicesWapper = styled.section`
    background-image: url(${ServicesBg});
    background-size: cover;
    background-position: center center;
    .about-row {
        align-items: center;
    }
    .aboutContent{
        padding-right: 100px;
    }
    .main-heading-about{
        display: inline-block;
        span{
            color: var(--text);
            display: unset;
            font-size: 40px;
            font-weight: var(--semiBold);
            &.servicesT2, &.aboutH3{
                color: var(--themeColor);
            }
        }
    }
    .about-h-row{
        margin-bottom: 80px;
    }
    .hStyled{
        font-size: 24px;
        font-family: var(--semibold);
        color: var(--themeColor);
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .abouImg{
        border-radius: 24px;
        overflow: hidden;
        span{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    .why-c-wapper{
        padding-right: 70px;
    }
    .expT1{
        padding-right: 200px;
    }
    .expCountNum{
        font-size: 64px;
        font-family: var(--familyRbt) !important;
        font-weight: 400;
        color: var(--themeColor);
    }
    .expCountRow{
        padding-bottom: 50px;
        margin-bottom: 70px;
        border-bottom: 1px solid var(--text);
    }
    .servBox{
        display: flex;
        width: 100%;
        background-position: center;
        background-size: cover;
        border-radius: 8px;
        min-height: 280px;
        padding: 40px;
        gap: 24px;
        height: 100%;
    }
    .servBoxNum{
        display: flex;
        width: 64px;
        min-width: 64px;
        height: 64px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background-color: var(--themeColor);
        color: var(--white);
        font-size: 24px;
        font-weight: 600;
    }
    .servBox1{
        background-image: url(${ServicesBg1});
    }
    .servBox2{
        background-image: url(${ServicesBg2});
    }
    .servBox3{
        background-image: url(${ServicesBg3});
    }
    .servBox4{
        background-image: url(${ServicesBg4});
    }
    .servBoxCol{
        margin-bottom: 20px;
    }
    .servBoxContWrap{
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        
        & > *{
            width: 100%;
            color: var(--white);
        }
        span.servTitle{
            font-family: var(--familyRbt);
            font-weight: 700;
            font-size: 25px;
            margin-top: 5px;
            margin-bottom: 15px;
        }
        span.servTxt{
            font-family: var(--familyRbt);
            font-weight: 500;
            font-size: 17px;
            line-height: 27px;
        }
    }

    body.rtl &{
        .abtHeadSec{
            font-size: 24px;
        }
        .aboutContent{
            padding-right: 0px;
            padding-left: 100px;
        }
        .main-heading-about{
            display: inline-block;
            span{
                display: unset;
                font-size: 40px;
                font-family: var(--arSemiBold);
            }
        }
        .hStyled{
            margin-top: 15px;
            font-size: 28px;
            font-family: var(--arSemiBold);
        }
        .why-c-wapper{
            padding-left: 70px;
            padding-right: 0;
        }
        .expT1{
            padding-right: 0;
            padding-left: 200px;
        }
        .servBoxContWrap{
            span.servTitle{
                font-family: var(--arSemiBold);
                font-size: 25px;

            }
            span.servTxt{
                font-family: var(--arMedium);
                font-size: 17px;
                line-height: 35px;
            }
        }
        
    }
    @media (max-width: 1199px) {
        .aboutContent {
            padding-right: 30px;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 30px;
            }
        }
    }
    @media (max-width: 991px) {
        .about-col{
            margin-bottom: 40px;
        }
        .about-col-img{
            display: none;
        }
        &.secAbout{
            padding-top: 60px;
            padding-bottom: 30px;
        }
        .main-heading-about{
            font-size: 35px;
        }
        .aboutContent{
            padding-right: 0;
        }
        .main-heading-about{
            span{
                font-size: 30px;
            }
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 0px;
            }
            .main-heading-about{
                span{
                    font-size: 30px;
                }
            }
        }
        
    }
    @media (max-width: 767px) {
        .servBox{
            flex-wrap: wrap;
            padding-left: 15px;
            padding-right: 15px;
        }
    }
    @media (max-width: 575px) {
        &.secAbout{
            padding-top: 50px;
            padding-bottom: 20px;
        }
        .main-heading-about{
            font-size: 30px;
        }
    }
`
export default Services
